<template>
  <div class="about">
    <div class="banner" :style="{ backgroundImage: 'url(' + nav.img + ')' }">
      <div class="wrapper">
        <h1>走进兴致力</h1>
        <p>Into Xingzhili</p>
      </div>
    </div>
    <div class="filter">
      <span
        :class="{ acitve: active == 'qualifications' }"
        @click="active = 'qualifications'"
        >荣誉资质</span
      >
      <span :class="{ acitve: active == 'history' }" @click="active = 'history'"
        >发展历程</span
      >
      <span
        :class="{ acitve: active == 'advantage' }"
        @click="active = 'advantage'"
        >品牌优势</span
      >
      <span
        :class="{ acitve: active == 'responsibility' }"
        @click="active = 'responsibility'"
        >社会责任</span
      >
      <span :class="{ acitve: active == 'culture' }" @click="active = 'culture'"
        >企业文化</span
      >
      <span
        :class="{ acitve: active == 'introduction' }"
        @click="active = 'introduction'"
        >公司简介</span
      >
    </div>
    <introduction id="introduction" />
    <culture id="culture" />
    <responsibility id="responsibility" />
    <advantage id="advantage" />
    <history id="history" />
    <qualifications id="qualifications" />
  </div>
</template>
<script>
import qualifications from '@/components/about/qualifications' //荣誉资质
import history from '@/components/about/history' //发展历程
import responsibility from '@/components/about/responsibility' //社会责任
import culture from '@/components/about/culture' //企业文化
import introduction from '@/components/about/introduction' //公司简介
import advantage from '@/components/about/advantage' //品牌优势
import { nav } from '../utils/api'
export default {
  components: {
    qualifications,
    history,
    responsibility,
    culture,
    introduction,
    advantage,
  },
  data() {
    return {
      active: 'introduction',
      nav: {},
    }
  },
  watch: {
    '$route.query.type': {
      handler(e) {
        this.active = e
      },
      deep: true,
    },
    active(e) {
      setTimeout(() => {
        console.log(e)
        let top = document.getElementById(e).offsetTop
        window.scrollTo(0, top)
      }, 200)
    },
  },
  mounted() {
    // 顶部图片
    this.active = this.$route.query.type || 'introduction'
    nav((r) => {
      this.nav = r.data
    })
  },
}
</script>
<style lang="less" scoped >
.banner::after {
  width: 100%;
  height: 100%;
  position: absolute;
  content: '';
  background: rgba(0, 0, 0, 0.2);
  z-index: 1;
  top:0;
  left: 0;
}
.banner {
  background-size: cover;
  background-repeat: no-repeat;
  height: 560px;
  margin-top: 0;
  position: relative;
  .wrapper {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;

    h1 {
      font-size: 38px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      // line-height: 65px;
      color: #ffffff;
      margin-bottom: 10px;
      position: relative;
      z-index: 2;
    }
    p {
      font-size: 18px;
      font-family: Arial;
      font-weight: 400;
      line-height: 21px;
      color: #ffffff;
      position: relative;
      z-index: 2;
    }
    p::after {
      content: '';
      position: absolute;
      bottom: -10px;
      left: 0;
      width: 80px;
      height: 4px;
      background: #ffffff;
    }
  }
}
.filter {
  width: 100%;
  padding: 0 calc(50% - 600px);
  margin: 0 auto;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  position: sticky;
  box-sizing: border-box;
  top: 0;
  z-index: 10;
  background: white;
  span {
    display: inline-block;
    cursor: pointer;
    height: 80px;
    line-height: 80px;
    text-align: center;
    width: 120px;
    font-size: 22px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #1a1a1a;
    position: relative;
  }
  span::after {
    content: '';
    width: 0;
    height: 4px;
    background: #006C8F;
    position: absolute;
    left: 0;
    bottom: 0;
    transition: all 0.15s linear;
  }
  span.acitve::after {
    width: 120px;
  }
}
@media (max-width: 767px) {
  .banner {
    height: 3.1rem;
    margin-top: 0;
    .wrapper {
      padding-left: 0.34rem;
      box-sizing: border-box;
      h1 {
        font-size: 0.32rem;
        margin-bottom: 0.12rem;
      }
      p {
        font-size: 0.2rem;
      }
      p::after {
        width: 0.86rem;
        bottom: -0.12rem;
      }
    }
  }
  /deep/.pub-sub-title {
    margin-bottom: 0.36rem !important;
  }
  .filter {
    width: 100%;
    flex-wrap: wrap;
    justify-content: space-between;
    span {
      height: 0.8rem;
      line-height: 0.8rem;
      font-size: 0.32rem;
      width: 2.5rem;
    }
  }
  .second {
    padding: 0.68rem 0.34rem;
    box-sizing: border-box;
  }
}
</style>